var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn  btn--quaternary",attrs:{"disabled":_vm.busy,"type":"button","name":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeItem.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.busy ? "Please wait..." : _vm.__("Remove"))+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fad2db2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Basket/Remove-from-cart.vue
// module id = y0Ca
// module chunks = 116